import { Box, Text, HStack, Badge, Stack } from "@chakra-ui/react";

interface CampaignTypeCardProps {
  type: string;
  title: string;
  description: string;
  isSelected: boolean;
  isDisabled: boolean;
  onClick: () => void;
  badges?: string[];
  icon?: React.ReactNode;
}

const CampaignTypeCard = ({
  type,
  title,
  description,
  isSelected,
  isDisabled,
  onClick,
  badges = [],
  icon,
}: CampaignTypeCardProps) => {
  return (
    <Box
      flex={1}
      aspectRatio={["initial", 1]}
      display={"flex"}
      gap={[2, 4]}
      alignItems={"center"}
      justifyContent={"center"}
      flexDirection={"column"}
      onClick={!isDisabled ? onClick : undefined}
      backgroundColor={isSelected ? "gray.100" : "white"}
      borderRadius={"lg"}
      p={4}
      borderWidth={2}
      borderColor={isSelected ? "blue.500" : "gray.200"}
      cursor={isDisabled ? "not-allowed" : "pointer"}
      opacity={isDisabled ? 0.5 : 1}
      h="full"
    >
      {icon || <Box width={100} height={100} backgroundColor="gray.100" />}
      <Text fontWeight={"bold"} fontSize={["xl", "2xl"]} textAlign={"center"}>
        {title}
      </Text>
      <Text fontSize={"xs"} color="gray.400" textAlign="center">
        {description}
      </Text>
      {badges.length > 0 && (
        <Stack direction={["column", "row"]}>
          {badges.map((badge, index) => (
            <Badge key={index} colorScheme="gray">
              {badge}
            </Badge>
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default CampaignTypeCard;
